import Vue from 'vue';
import Vuex from 'vuex';

import areas from './modules/areas';
import departments from './modules/departments';
import enterprises from './modules/enterprises';
import payrollClasification from './modules/payroll-clasification';
import payrollClasificationCustomReport from './modules/payroll-clasification-custom-report';
import payroll from './modules/payroll';
import payrollCategories from './modules/payroll-categories';
import payrollTypes from './modules/payroll-types';
import organizationChart from './modules/organization-chart';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    areas,
    departments,
    enterprises,
    organizationChart,
    payrollClasification,
    payrollClasificationCustomReport,
    payroll,
    payrollCategories,
    payrollTypes,
  }
});

export default store;
